'use strict';
/**
 * A service to get user responses to activities.
 */

angular.module('msActivityServices').service('activityResponseSvc', ['httpSvc', 'context', function (httpSvc, context) {
  return {
    getResponses: getResponses,
    viewResponse: viewResponse
  };

  /**
   * Get all of the user's responses
   * @return {Map<Activity, List<Response>>} A map of the activities to a list of responses
   */
  function getResponses(activityUrl) {
    var url = '/apiproxy/user/activities/responses?context=' + context;
    if (activityUrl) {
      url = url + '&url=' + activityUrl;
    }
    return httpSvc.get(url);
  }

  /**
   * Utility fn used to Route the user to a detail view of a response
   */
  function viewResponse(responseId, activityRouter) {
    activityRouter.showHistory({
      response: responseId
    });
  }
}]);